import React from "react";
import "../assets/css/carousel.css";
import C1 from '../assets/images/c1.jpg'
import C2 from '../assets/images/c2.jpg'
import C3 from '../assets/images/c3.jpg'
function Carousel() {
  const ImgData = [
    {
      src: C1,
      alt: "Carsouel1",
    },
    {
      src: C2,
      alt: "Carsouel2",
    },
    {
      src: C3,
      alt: "Carsouel3",
    },
  ];
  return (
    <div
      id="carouselExampleControls"
      className="carousel carousel-dark slide"
      data-bs-ride="carousel"
    >
      <div className="carousel-inner">
        <div className="carousel-item active">
          <div className="imgCaroselContainer">
            <img src={C3} className="CaroselImg d-block w-100" alt={ImgData[0].alt} />
          </div>
        </div>
        {ImgData.map((value, idx) => (
          <div key={idx} className="carousel-item">
            <div className="imgCaroselContainer">
              <img src={value.src} className="CaroselImg" alt={value.alt} />
            </div>
          </div>
        ))}
      </div>
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleControls"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleControls"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
}

export default Carousel;
